import React, { useEffect, useState, Suspense, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import Loading from './Loading';
import { useAuthStore } from '../stores/authStore';
import { privateRoutes, publicRoutes } from '../config/routesConfig';
import AuthGuard from '../components/auth/AuthGuard';
import GuestGuard from '../components/auth/GuestGuard';
import NotFoundPage from '../pages/NotFound';
import BaseLayout from './BaseLayout';

const ConfigRoutes = () => {
  const { isCheckingAuth, checkAuth } = useAuthStore();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthentication = async () => {
      await checkAuth();
      setIsLoading(false);
    };

    checkAuthentication();
  }, [checkAuth]);

  const memoizedPublicRoutes = useMemo(
    () =>
      publicRoutes.map(route => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <GuestGuard>
              <route.element />
            </GuestGuard>
          }
        />
      )),
    [publicRoutes]
  );

  const memoizedPrivateRoutes = useMemo(
    () =>
      privateRoutes.map(route => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <AuthGuard>
              <route.element />
            </AuthGuard>
          }
        />
      )),
    [privateRoutes]
  );

  if (isLoading || isCheckingAuth) return <Loading />;

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {memoizedPublicRoutes}
        <Route element={<BaseLayout />}>{memoizedPrivateRoutes}</Route>
        {/* Not found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default React.memo(ConfigRoutes);
